import _objectSpread from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { M as r } from "./abstract-base-8edf0a84-e11d45a3.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function o(t) {
  return r(_objectSpread({}, t, {
    state: !0,
    attribute: !1
  }));
}
export { o as e };